//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/電柱ポップアップ
//------------------------------------------------------------------------------
import Point from '@arcgis/core/geometry/Point';
import mapUtils from '@/utils/map-utils';
import PoleItem from '@/utils/pole-item';
import closePopup from './close-popup.js'

// 定数
const LOGH = 'BFA10103G pole popup:';

/**
 * 選択電柱ポップアップ
 */
export async function openPolePopup(view, layers, poleSelected) {
  if (!view || !layers) {
    return;
  }

  // 選択電柱なしならポップアップ非表示
  if (!poleSelected?.drawable()) {
    closePopup(view);
    return;
  }

  // 既にポップアップ表示済の場合は何もしない
  if (view.popup.visible) {
    for (const graphic of view.popup.features) {
      const type = graphic.attributes?.type;
      switch (type) {
        case 'pole': break;
        case 'setubi': break;
        default: continue;
      }
      const pole = graphic.attributes.pole;
      if(poleSelected.same(pole)) {
        return;
      }
    }
  }

  // 設備一覧の電柱グラフィックを検索
  // 設備一覧になければ電柱一覧を検索
  const graphic = findGraphic(poleSelected, [layers.setubi, layers.pole]);

  // どちらにもなければ電柱マスタを検索
  const feature = graphic || await findMasterLayer(poleSelected, layers);
  if (!feature) {
    return;
  }

  // 電柱ポップアップ
  view.openPopup({
    location: feature.geometry,
    features: [ feature ],
  });

  // 電柱が表示範囲外ならビュー移動
  if (!view.extent.contains(feature.geometry)) {
    view.goTo(feature, mapUtils.GOTO_OPTIONS)
        .catch((err) => console.info(LOGH, err.message));
  }
}

// 電柱グラフィック検索
function findGraphic(pole, layers) {
  for (const layer of layers) {
    const graphic = layer.graphics.find(
        (g) => PoleItem.same(pole, g.attributes?.pole));
    if (graphic) {
      return graphic;
    }
  }
  return null;
}

// 電柱マスタレイヤー検索
async function findMasterLayer(poleSelected, layers) {
  const masterView = layers.masterView;
  if (!masterView) return null;

  const query = masterView.createQuery();
  query.geometry = new Point({
    latitude: poleSelected.latitude,
    longitude: poleSelected.longitude,
  });
  query.distance = 10;

  // 緯度経度でレイヤー検索
  const result = await masterView.queryFeatures(query);
  for (const feature of result.features) {
    const pole = new PoleItem(feature.attributes);

    // 電柱一致判定
    if (poleSelected.same(pole)) {
      return feature;
    }
  }
  return null;
}

// デフォルトエクスポート
export default openPolePopup;
